import { render } from "./AccountSettingView.vue?vue&type=template&id=af18a6a4"
const script = {}
script.render = render

export default script